import { LeadPaymentLink } from '@/api/types/crm.types'
import { ClassInfoType } from '@pages/Admin/ManageClassSettings/types'
import { selectIsAuth, selectProfile } from '@store/profile.reducer'
import { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import cn from './index.module.css'
import ExtraPurchaseFieldsView from '@pages/CoursesCatalog/modals/CourseEnrollmentModal/components/ExtraPurchaseFieldsView/ExtraPurchaseFieldsView'
import { useGetSettings } from '@pages/CoursesCatalog/tabs/CatalogCoursesTab/hooks/getPlatformSettings'
import { useGetExtraPurchaseFields } from '@pages/Admin/PlatformSettings2/DirectorySettings/components/ExtraPurchaseFields/utils'
import { jsonConvert } from '@/helpers/jsonConvert'
import { smsIntegrationApi } from '@/api'
import {
  ICheckEmailOrPhoneResponse,
  IEnrollmentProfileData,
} from '@pages/CoursesCatalog/modals/CourseEnrollmentModal/utils/api'
import SliderField from '@pages/Admin/CourseSettings/components/SliderField/SliderField'
import ClassPriceView from '../ClassPriceView/ClassPriceView'
import ClassEnrollmentFooter from '../ClassEnrollmentFooter/ClassEnrollmentFooter'
import { useAddAlert } from '@/hooks/useAddAlert'
import Preloader from '@UI/Preloader'
import {
  checkIsEmail,
  checkIsPhone,
  checkPassword,
} from '@pages/CoursesCatalog/modals/CourseEnrollmentModal/utils/validation'
import SuccessfullyEnrollmentStub from '../SuccessfullyEnrollmentStub/SuccessfullyEnrollmentStub'
import { useHistory } from 'react-router-dom'
import { classEnrollment } from '../../utils/api'
import moment from 'moment'
import PromoCodeField from '@pages/CoursesCatalog/modals/CourseEnrollmentModal/components/PromoCodeField/PromoCodeField'
import { getPriceWithDiscount } from '@pages/CoursesCatalog/modals/CourseEnrollmentModal/utils/tariff'
import ShowClassValue from '../ShowClassValue/ShowClassValue'

interface IClassEnrollmentBody {
  classData: ClassInfoType | null
  classLinkData: LeadPaymentLink | null
  userId?: number
  onSuccess: () => void
}

const ClassEnrollmentBody: FC<IClassEnrollmentBody> = ({
  classData,
  classLinkData,
  userId,
  onSuccess,
}) => {
  const addAlert = useAddAlert()
  const { extraFields } = useGetExtraPurchaseFields()
  const isAuth = useSelector(selectIsAuth)
  const profile = useSelector(selectProfile)
  const classState = classData ?? classLinkData?.class
  const history = useHistory()
  const [value, setValue] = useState(1)
  const { checkSettings, getSettings, loadingSettings } = useGetSettings()
  const registrationTypeForCatalog =
    getSettings('registrationTypeForCatalog') ?? 'email' // тип регистрации
  const sms_integration_enabled = checkSettings('sms_integration_enabled') // активна ли интеграция с смс
  const confirmationByPhoneNumber = checkSettings('confirmationByPhoneNumber') // есть вариант подтвердить по смс на телефон
  const confirmationByTelegram = checkSettings('confirmationByTelegram') // есть вариант подтвердить по телеграмм
  const requiredNumberConfirmationForCatalog = checkSettings(
    'requiredNumberConfirmationForCatalog',
  ) // обязательно ли подтверждать телефон
  const [userExistedData, setUserExistedData] =
    useState<ICheckEmailOrPhoneResponse>({
      // найденный пользователь с введенным email или телефоном
      user: null,
      hasCourse: false,
      roles: [],
      directions: [],
    })
  const [parentExistedData, setParentExistedData] =
    useState<ICheckEmailOrPhoneResponse>({
      user: null,
      hasCourse: false,
      roles: [],
      directions: [],
    })
  const [code, setCode] = useState('') //код для подтверждения
  const [token, setToken] = useState('') //токен для подтверждения
  const [loading, setLoading] = useState<boolean>(false)
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const [codeDeliveryMethod, setCodeDeliveryMethod] = useState('') // 'sms' или 'telegram'//выбранный метод пользователем
  const [validationErrors, setValidationErrors] = useState<
    (keyof IEnrollmentProfileData)[]
  >([])
  const [promoCodeDiscount, setPromoCodeDiscount] =
    useState<IPromoCodeDiscount | null>(null)
  const [user, setUser] = useState<IEnrollmentProfileData>({
    studentName: '',
    studentEmail: '',
    studentPhone: '',
    password: '',
    parentName: '',
    parentPhone: '',
    parentEmail: '',
    parentPassword: '',
    customText: '',
  })

  const updateUser = (field: keyof IEnrollmentProfileData, value: string) => {
    setUser((prev) => {
      return { ...prev, [field]: value }
    })
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)

    const updatedUser = { ...user }

    for (const key of params.keys()) {
      if (key in updatedUser) {
        const value = params.get(key)
        if (value !== null) {
          ;(updatedUser as any)[key] = value.slice(0, 200)
        }
      }
    }

    setUser(updatedUser)
  }, [])

  useEffect(() => {
    setValue(classLinkData?.value ?? 1)
  }, [classLinkData])

  const userHasCourse = userExistedData?.user && userExistedData?.hasCourse

  const getTokenFromServer = () => {
    smsIntegrationApi
      .getToken({
        phone: user.parentPhone,
        type: [codeDeliveryMethod],
      })
      .then((res) => {
        if (res?.data?.status === 'success') {
          setToken(res?.data?.token)
          addAlert({
            title: 'Код отправлен',
            text: 'Заполните поле с кодом подтверждения',
          })
        } else {
          addAlert({
            title: 'Ошибка',
            // @ts-ignore
            text: res?.response?.data?.error,
            type: 'error',
          })
        }
      })
  }

  const smsIntegrationEnabled =
    sms_integration_enabled &&
    requiredNumberConfirmationForCatalog &&
    (confirmationByPhoneNumber || confirmationByTelegram) &&
    registrationTypeForCatalog === 'phone' &&
    !userExistedData.user
  // нужно ли подтверждать номер исходя их всех условий

  const getToken = !token && smsIntegrationEnabled // нужно ли получать токен
  const showAdditionalField = !userExistedData?.user
  const showParentAdditionalField = !parentExistedData?.user

  const validateForm = (): boolean => {
    if (isAuth) return true
    const userWrongRole = !userExistedData?.roles?.includes('children')
    if (!!userExistedData.user && userWrongRole) {
      addAlert({
        title:
          'Данная почта привязана к личному кабинету сотрудника/родителя, впишите другую',
        type: 'error',
      })
      return false
    }

    const errors: string[] = []
    if (
      !userId && // если передан user_id из crm, то не проверяем поля студента
      showAdditionalField &&
      extraFields.includes('studentName') &&
      user?.studentName.length < 3
    ) {
      errors.push('studentName')
    }
    if (
      !userId && // если передан user_id из crm, то не проверяем поля студента
      !checkIsEmail(user.studentEmail) &&
      extraFields.includes('studentEmail')
    ) {
      errors.push('studentEmail')
    }
    if (
      !userId && // если передан user_id из crm, то не проверяем поля студента
      !checkIsPhone(user.studentPhone) &&
      extraFields.includes('studentPhone')
    ) {
      errors.push('studentPhone')
    }
    if (
      !userId && // если передан user_id из crm, то не проверяем поля студента
      showAdditionalField &&
      extraFields.includes('password') &&
      !checkPassword(user.password)
    ) {
      if (!checkPassword(user.parentPassword)) {
        addAlert({ text: 'Пароль не должен содержать кирилицу', type: 'error' })
      }
      errors.push('password')
    }
    if (
      showAdditionalField &&
      showParentAdditionalField &&
      extraFields.includes('parentName') &&
      user.parentName.length < 3
    ) {
      errors.push('parentName')
    }
    if (
      showAdditionalField &&
      showParentAdditionalField &&
      extraFields.includes('parentEmail') &&
      (!checkIsEmail(user.parentEmail) ||
        user.parentEmail === user.studentEmail)
    ) {
      errors.push('parentEmail')
    }
    if (
      showAdditionalField &&
      showParentAdditionalField &&
      extraFields.includes('parentPhone') &&
      (!checkIsPhone(user.parentPhone) ||
        user.parentPhone === user.studentPhone)
    ) {
      errors.push('parentPhone')
    }
    if (
      showAdditionalField &&
      showParentAdditionalField &&
      extraFields.includes('parentPassword') &&
      !checkPassword(user.parentPassword)
    ) {
      if (!checkPassword(user.parentPassword)) {
        addAlert({ text: 'Пароль не должен содержать кирилицу', type: 'error' })
      }
      errors.push('parentPassword')
    }

    setValidationErrors(
      (prev) => Array.from(new Set(errors)) as (keyof IEnrollmentProfileData)[],
    )

    if (errors?.[0]) {
      let error = 'Ошибка на форме'
      switch (errors?.[0] as keyof IEnrollmentProfileData) {
        case 'studentName':
          error = 'Заполните ФИО'
          break
        case 'studentEmail':
          error = 'Проверьте Email'
          break
        case 'studentPhone':
          error = 'Проверьте Телефон'
          break
        case 'password':
          error = 'Пароль должен быть заполнен'
          break
        case 'parentName':
          error = 'Заполните ФИО родителя'
          break
        case 'parentEmail': {
          if (user.parentEmail === user.studentEmail) {
            error = 'Email родителя и учащегося не должны совпадать'
          } else {
            error = 'Проверьте Email родителя'
          }
          break
        }
        case 'parentPhone':
          if (user.parentPhone === user.studentPhone) {
            error = 'Телефон родителя и учащегося не должны совпадать'
          } else {
            error = 'Проверьте поле Телефон родителя'
          }
          break

        default:
          break
      }

      addAlert({
        title: error,
        type: 'error',
      })
      return false
    }
    return true
  }

  const discountValue = Number(
    (value * (classLinkData?.discount ?? 0)).toFixed(2),
  )
  const startPrice = Number(
    (value * (classLinkData?.price ?? classData?.amount ?? 0)).toFixed(2),
  )
  const currentPrice = Number(
    getPriceWithDiscount(
      value * (classLinkData?.price ?? classData?.amount ?? 0) - discountValue,
      promoCodeDiscount,
    ),
  )

  const onEnroll = async () => {
    setLoading(true)

    if (validateForm()) {
      let newWindow = window.open('', '_blank')
      if (newWindow) {
        newWindow.document.body.innerHTML = '<p>Подготовка к оплате...</p>'
      }
      const res = await classEnrollment(
        currentPrice,
        classData?.id,
        classLinkData?.id,
        value,
        promoCodeDiscount,
        user,
        token,
        code,
        !!userExistedData?.user,
        userId,
      )
      if (res.status === 'success') {
        addAlert({
          title: 'Класс приобретен!',
        })
        setIsSuccess(true)
        onSuccess()
        const paymentLink = res?.data?.payment_link

        if (paymentLink && newWindow) {
          newWindow.location.href = paymentLink
        } else if (newWindow) {
          newWindow.document.body.innerText = 'Ссылка на оплату не найдена.'
        }
        if (!isAuth) {
          history.push('/auth')
        }
      } else {
        if (newWindow) {
          newWindow.document.body.innerText =
            'Произошла ошибка. Попробуйте позже.'
        }
        addAlert({
          title: 'Возникла ошибка!',
          type: 'error',
        })
      }
    }
    setLoading(false)
  }

  if (loadingSettings) {
    return <Preloader />
  }

  if (isSuccess) {
    return <SuccessfullyEnrollmentStub title="Поздравляем с покупкой класса" />
  }

  return (
    <div className={cn.container}>
      {!isAuth && (
        <ExtraPurchaseFieldsView
          classId={classState!.id}
          userId={userId}
          profile={user}
          updateProfile={updateUser}
          token={token}
          code={code}
          setCode={setCode}
          userExistedData={userExistedData}
          setUserExistedData={setUserExistedData}
          parentExistedData={parentExistedData}
          setParentExistedData={setParentExistedData}
          codeDeliveryMethod={codeDeliveryMethod}
          setCodeDeliveryMethod={setCodeDeliveryMethod}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      )}
      {!!classLinkData?.value ? (
        <ShowClassValue value={value} />
      ) : (
        <SliderField
          label={'Период'}
          value={value}
          extraContent={value?.toString()}
          min={1}
          max={24}
          onChange={setValue}
        />
      )}

      {classLinkData?.is_promo_enabled !== false && (
        <PromoCodeField
          userId={profile?.id ?? userExistedData?.user?.id ?? null}
          code={promoCodeDiscount}
          setCode={setPromoCodeDiscount}
        />
      )}
      {classLinkData?.enroll_date && (
        <div className={cn.enrollDateString}>
          Оплата за курс с{' '}
          {moment(classLinkData?.enroll_date).format('DD.MM.YYYY')}
        </div>
      )}
      <ClassEnrollmentFooter
        showLogIn={!!userHasCourse}
        loading={loading}
        currentPrice={currentPrice}
        startPrice={startPrice}
        promoDiscount={promoCodeDiscount}
        onAction={getToken ? getTokenFromServer : onEnroll}
        disabledButton={
          !!parentExistedData.user &&
          !parentExistedData?.roles?.includes('parent')
        }
      />
    </div>
  )
}

export default ClassEnrollmentBody
